"use client";

import { Calendar as HeroCalendar } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Calendar = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroCalendar>) => {
  return <HeroCalendar className={cn(className)} {...props} />;
};
